// Splits a flat list into fixed-size rows. Virtualized grids scroll by row, not by item, so the item
// list has to be pre-chunked into the rows the CSS grid is currently painting (see useGridColumnCount).
export const chunkIntoRows = (items, rowSize) => {
    const size = Math.max(1, Math.floor(rowSize));
    const rows = [];
    for (let index = 0; index < items.length; index += size) {
        rows.push(items.slice(index, index + size));
    }
    return rows;
};
